/** Bailian 集成 API；请求与响应契约来自 shared，API Key 永不回显。 */
import type {
  BailianCredentialResponse,
  UpsertBailianCredentialRequest,
} from '@novel-admin/shared';
import { apiRequest } from '~/api/client';

export const bailianApi = {
  /** 读全局凭证视图（掩码；未配置 → configured:false） */
  getCredential: () =>
    apiRequest<BailianCredentialResponse>({
      method: 'GET',
      path: '/api/v1/integrations/bailian/credential',
    }),
  /** 录 / 换全局 百炼 Key（后端先读取模型目录验证再加密存；明文仅提交） */
  upsertKey: (body: UpsertBailianCredentialRequest) =>
    apiRequest<BailianCredentialResponse>({
      method: 'PUT',
      path: '/api/v1/integrations/bailian/credential',
      body,
    }),
  /** 移除全局凭证配置，可重新录入 */
  removeKey: () =>
    apiRequest<{ removed: true }>({
      method: 'DELETE',
      path: '/api/v1/integrations/bailian/credential',
    }),
  /** 测试连接（解密已存 Key + 读取百炼模型目录，不产生生成费用） */
  testConnection: () =>
    apiRequest<{ connected: true }>({
      method: 'POST',
      path: '/api/v1/integrations/bailian/credential/test',
    }),
};
